module.exports = __webpack_public_path__ + "img/Temps.233c18a0.png";